import type {
  CalendarFestival,
  CalendarTodayResponse,
  CalendarMonthResponse,
  CalendarUpcomingResponse,
  CalendarFestivalDetail,
  CalendarEkadashiResponse,
} from "@ishvaram/api-client";
import { apiRequest } from "./_fetch";

export type {
  CalendarFestival,
  CalendarTodayResponse,
  CalendarMonthResponse,
  CalendarUpcomingResponse,
  CalendarFestivalDetail,
  CalendarEkadashiResponse,
};

// The Ekadashi list element carries the full FestivalSummary shape from the
// backend (incl. `month_hi`), which the hand-maintained `CalendarFestival`
// override omits. Derive it from the response so consumers get the real fields.
export type CalendarEkadashiItem = CalendarEkadashiResponse["ekadashis"][number];

export async function getCalendarToday(date?: string): Promise<CalendarTodayResponse> {
  const params = new URLSearchParams();
  if (date) params.set("date", date);
  const qs = params.toString();
  return apiRequest<CalendarTodayResponse>(`/calendar/today${qs ? `?${qs}` : ""}`);
}

export async function getCalendarMonth(
  year: number,
  month: number
): Promise<CalendarMonthResponse> {
  return apiRequest<CalendarMonthResponse>(`/calendar/month?year=${year}&month=${month}`);
}

export async function getCalendarUpcoming(
  days = 30,
  date?: string
): Promise<CalendarUpcomingResponse> {
  const params = new URLSearchParams({ days: String(days) });
  if (date) params.set("date", date);
  return apiRequest<CalendarUpcomingResponse>(`/calendar/upcoming?${params.toString()}`);
}

export async function getCalendarEkadashi(year = 2026): Promise<CalendarEkadashiResponse> {
  return apiRequest<CalendarEkadashiResponse>(`/calendar/ekadashi?year=${year}`);
}

export async function getCalendarFestival(id: string): Promise<CalendarFestivalDetail> {
  return apiRequest<CalendarFestivalDetail>(`/calendar/festival/${id}`);
}
